module.exports = __webpack_public_path__ + "static/media/date.2f4258ef.svg";